import keyBy from 'lodash/keyBy'
import { replaceEntities, replaceCollections, deleteEntities } from '@fakundo/redux-entities'
import { REQUESTS, ALL_REQUESTS } from 'constants/entityNames'

export const fetchRequests = cancelToken => (
  (dispatch, getState, api) => api({
    apiPath: 'requests',
    cancelToken
  })
)

export const refetchRequests = cancelToken => (
  async (dispatch) => {
    const data = await dispatch(fetchRequests(cancelToken))
    dispatch(replaceCollections({ [ALL_REQUESTS]: { ...keyBy(data, 'id') } }))
  }
)

export const fetchRequest = (id, cancelToken) => (
  (dispatch, getState, api) => api({
    apiPath: `requests/${id}`,
    cancelToken
  })
)

export const refetchRequest = (requestId, cancelToken) => (
  async (dispatch) => {
    const request = await dispatch(fetchRequest(requestId, cancelToken))
    dispatch(replaceEntities(REQUESTS, { [request.id]: request }))
    dispatch(replaceEntities(ALL_REQUESTS, { [request.id]: request }))
  }
)

export const patchRequest = (id, data, cancelToken) => (
  async (dispatch, getState, api) => {
    const request = await api({
      method: 'patch',
      apiPath: `requests/${id}`,
      data,
      cancelToken
    })
    // @todo
    dispatch(replaceEntities(REQUESTS, { [request.id]: request }))
    dispatch(replaceEntities(ALL_REQUESTS, { [request.id]: request }))
  }
)

export const createFollowup = (requestId, data, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: `followups/${requestId}`,
      data,
      cancelToken
    })
    const request = await dispatch(fetchRequest(requestId, cancelToken))
    dispatch(replaceEntities(REQUESTS, { [request.id]: request }))
  }
)

export const readRequestEmail = (requestId, emailId, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      apiPath: `requests/${requestId}/read/${emailId}`,
      cancelToken
    })
    await dispatch(refetchRequest(requestId))
  }
)

export const bulkDeleteRequests = (requestIds, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'delete',
      apiPath: 'requests/batch',
      data: { requestList: requestIds },
      cancelToken
    })
    // @todo
    dispatch(deleteEntities(REQUESTS, ...requestIds))
    dispatch(deleteEntities(ALL_REQUESTS, ...requestIds))
  }
)

export const bulkPatchRequestStatuses = (requestIds, status, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'patch',
      apiPath: 'requests/batch',
      data: { requestList: requestIds, status },
      cancelToken
    })
    // @todo
    dispatch(deleteEntities(REQUESTS, ...requestIds))
    await dispatch(refetchRequests())
  }
)
